import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  Image,
  Modal,
  Row,
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import {  useLocation, useNavigate } from "react-router";
import rightBannerSvg from "../../assets/images/right_banner.png";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import { createOTP, verifyOTP } from "../../services/api";
import parse from "html-react-parser";

function VerifyForm(props) {
  const { intl, otpData,  setotpData } = props;
  let data = otpData.verifyForm;
  const [show, setshow] = useState(false);
  const [otpErr, setotpErr] = useState('')
  const shbLink = process.env.REACT_APP_SHB_SIGN_IN_LINK;

  const [message, setmessage] = useState({
    title: "",
    content: ""
  })
  const location = useLocation()
  const [success, setsuccess] = useState(false)

  const handleTextChange = (name, e) => {
    let value = e.target.value;
    if(value){
      value = value.trim();
      setotpErr('');
    }
    setotpData({...otpData, verifyForm: {...data, [name]: value}})
  }

  const navigate = useNavigate();

  //call api to verify otp and generate password, send it through email
  const onVerify = (e) => {
    if(!validateInput()){
      setotpErr(parse(intl.formatMessage({id: "verifyForm.fail"})))
      return;
    }

    setotpData({...otpData, loading: true})
    verifyOTP({...data, ...otpData.forgetPass}).then(response => {
      offProgress()
      if(response.data && response.data.content && response.data.content.STATUS === 'SUCCESS'){
        showMessage({title: parse(intl.formatMessage({id: "verifyForm.success.title"})),content: parse(intl.formatMessage({id: "verifyForm.success"}))})
        setsuccess(true);
        setotpErr('');
        // updateOtpData({...otpData, check: false});
        // navigate(process.env.REACT_APP_SHB_SIGN_IN_LINK)
      }else{
        setotpErr(parse(intl.formatMessage({id: "verifyForm.fail"})))
      }
    }).catch(err => {
      offProgress()
      setotpErr(parse(intl.formatMessage({id: "verifyForm.fail"})))
    })
  }

  const closeDialog = () => {
    setshow(false);
    if(success){
      window.location.assign(shbLink);
    }
  }

  useEffect(() => {
    if(data.otpTimeout){
      const otpTimeout = data.otpTimeout;
      const otpTimeoutStr = `${Math.floor(otpTimeout/60)}`.padStart(2,0) + ':' + `${otpTimeout%60}`.padStart(2,0);
      // setdata({...data,...location.state,...location.state.data, ...location.state.otpInfo,
        // otpTimeoutStr})
        setotpData({...otpData, verifyForm: {...otpData.verifyForm, otpTimeout, otpTimeoutStr}})
    }
  }, [location.state && location.state && !data.otpTimeout])



  useEffect(() => {
    setTimeout(() => {console.log(otpData)}, 2000)
  }, [otpData])


  useEffect(() => {
    // const {otpTimeout, countDown} = data
    // if (otpTimeout <= 0 || countDown <= 0) {
    //   return;
    // }

    setTimeout(() => {
      const otpTimeout = data.countDown - Math.floor(Date.now() / 1000);
      let otpTimeoutStr = "";
      if(data.otpTimeoutStr === "00:00"){
        return;
      }
      if(otpTimeout <= 0){
        otpTimeoutStr = "00:00"
      }else{
        otpTimeoutStr = `${Math.floor(otpTimeout/60)}`.padStart(2,0) + ':' + `${otpTimeout%60}`.padStart(2,0);
      }

      setotpData(otpData => ({...otpData, verifyForm: {...otpData.verifyForm, otpTimeout, otpTimeoutStr}}))
    }, 1000);
  }, [otpData]);

  const validateInput = () => {
    if(!data || !data.otp || data.otp === ''){
      return false;
    }

    return true;
  }

  const onBack = () => {
    setotpData({...otpData, check: false})
    // navigate("/quen-mat-khau")
  }

  const showProgress = () => {
    setotpData({...otpData, loading: true});
  }

  const offProgress = () => {
    setotpData({...otpData, loading: false});
  }

  const showMessage = (msg) => {
    setmessage(msg);
    setshow(true);
  }

  const updateOtpData = (obj)=> {
    setotpData({...obj})
  }

  const resendOTP = () => {
    const {custId , role , email , phone, userName } = otpData.forgetPass;
    showProgress();
    setotpErr('');
    createOTP({custId , role , email , phone, userName  }).then(response => {
      offProgress();
      if(response.data && response.data.content){
        if(response.data.content.STATUS == 'SUCCESS'){
          const resData = response.data && response.data.content && response.data.content.data;
          const countDown =  Math.floor(Date.now() / 1000) + resData.otpTimeout;
          updateOtpData({...otpData, verifyForm: {...data, ...resData, countDown, otpTimeoutStr: ''}})
        }else{
          showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
        }
      }else{
        showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
      }
    }).catch(err => {
      offProgress();
      showMessage({content: parse(intl.formatMessage({id: "forgetPass.error"}))})
    })
  }

  return (

    <div>
      <Container className="container-collapse" style={{ paddingLeft: "90px" }}>
        <Row className="m-0 px-0">
          <Col xs={12} sm={5} md={5} lg={5} xl={5} xxl={5} className="m-0 p-0">
            <Col xs={12} sm={10} md={10} lg={10} xl={10} xxl={10} className="m-0 p-0">
            <div className="justify-content-center content-landing-page">
              <Card className="bg-transparent border-0">
                <Card.Body className=" p-0">
                  <Card.Title className="d-flex justify-content-center">
                    <strong><FormattedMessage id={"verifyForm.title"} /></strong>
                  </Card.Title>
                  <Form.Group className="mb-1">
                    <Form.Label>
                      <strong><FormattedMessage id={"verifyForm.otp"} /></strong>
                    </Form.Label>
                    <Form.Control
                    value={otpData.verifyForm.otp}
                    placeholder={parse(intl.formatMessage({id: "verifyForm.placeHolder"}))}
                    onChange={e => handleTextChange('otp', e)}/>
                    <p className="text-danger">{otpErr}</p>
                  </Form.Group>

                  <Form.Group className="mb-1">
                    <p className="text-center">
                      {data.otpTimeoutStr} <button
                      disabled={data.otpTimeoutStr !=="00:00"}
                      onClick={resendOTP}
                      className="border-0 bg-transparent"
                      style={{textDecoration: "none"}}>
                        <strong style={{color: "#F2994A"}}><FormattedMessage id={"verifyForm.resend"} /></strong>
                        </button>
                    </p>
                  </Form.Group>

                  <Form.Group className="mt-4 mb-4 d-grid ">
                    <button className="btn fill-submit-btn"
                      onClick={onVerify}>
                      <strong><FormattedMessage id={"verifyForm.confirm"} /></strong>
                    </button>
                  </Form.Group>

                  <Form.Group className="mb-4 d-grid">
                    <button className="btn outline-btn" onClick={onBack} >
                    <strong ><FormattedMessage id={"verifyForm.back"} color={"#F2994A"}/></strong>
                    </button>
                  </Form.Group>
                </Card.Body>
              </Card>

              <Modal show={show}>
                <Modal.Body >
                  {message && message.title &&
                  <div className="d-flex justify-content-center">
                  <p style={{fontWeight: "500"}} className="text-center">{message.title}</p>
                  </div>
                  }
                  <div className="d-flex justify-content-center">
                  <p className="text-center" style={{width:"60%"}}>
                    {message.content}
                  </p>
                  </div>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn outline-btn"
                      onClick={closeDialog}
                    >
                      <FormattedMessage id={"verifyForm.close"} ></FormattedMessage>
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </Col>
          </Col>
          <Col
            xs={7}
            sm={7}
            md={7}
            lg={7}
            xl={7}
            xxl={7}
            style={{ textAlign: "right" }}
            // className="header-right-banner"
          >
            <Image src={rightBannerSvg} style={{ width: "100%" }}></Image>
          </Col>
        </Row>

        {data.loading && <LoadingSpinner /> }
      </Container>
    </div>
  );
}

export default injectIntl(VerifyForm);
